<div class="sidebar" [class.collapsed]="isCollapsed">
  <button class="toggle-btn" (click)="toggleSidebar()">
    <mat-icon svgIcon="menu_open" class="icon-sm" [ngClass]="!isCollapsed ?  'openmenu' : 'closemenu' "></mat-icon>
  </button>
  <nav role="navigation">
    <ul class="menu">


      @if (menuItemsLoading) {
        <li class="menu-item" *ngFor="let item of skeletonItems">
          <div class="skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </li>
      } @else {
        <ng-container *ngFor="let item of menuItems; let i = index">
      <li *ngIf="isMenuVisible(item) && (item.page !== EnvironmentPages.SIZING_DOCUMENTS || (solutionVersionLoaded && showSizingDocuments)) && (item.page !== EnvironmentPages.DEPENDENCY_TREE || showDependencyTree) && (item.page !== EnvironmentPages.EF_TEST || showEFTest)" class="menu-item" [id]="item.id"
      [ngClass]="{'border': item.border, 'active': item.active}"
      (click)="menuClick.emit(item.page); activeMenu(item)"
      tabindex="{{ i === activeIndex ? 0 : -1 }}"
      (keydown)="onKeydown($event, i)"
      [class.tab]="i === activeIndex" [matTooltipClass]="isCollapsed ? 'menu-tooltip p-8 right' : '' " [matTooltip]="isCollapsed ? item.label : ''" matTooltipPosition="{{Constants.POSITION_RIGHT}}">
        <span class="icon">
            <mat-icon [svgIcon]="item.icon" class="icon-sm" [ngClass]="isCollapsed ? 'ml-10' : 'mr-10'"></mat-icon>
        </span>
        <span class="label fw-400" *ngIf="!isCollapsed">{{ item.label }}</span>
        <mat-spinner *ngIf="!isCollapsed && inprogressPage === item.page" diameter="16"
          class="ml-auto op-status-spinner"
          [matTooltip]="getOpTooltip('inprogress')" [matTooltipClass]="'menu-tooltip p-8 right'" matTooltipPosition="right">
        </mat-spinner>
        <mat-icon *ngIf="!isCollapsed && failedPage === item.page" svgIcon="warning_amber"
          class="icon-sm ml-auto warn-solid-fg"
          [matTooltip]="getOpTooltip('failed')" [matTooltipClass]="'menu-tooltip p-8 right'" matTooltipPosition="right">
        </mat-icon>
      </li>
        </ng-container>
      }
    </ul>
  </nav>
</div>